import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

export default function Connect() {
  return (
    <>
      <Header />

      <div
        class="container"
        style={{ paddingTop: 185 }}
      >
        <div class="row p-5">
          <div class="col-lg-6 mb-9 mb-lg-0">
            <div class="mb-5">
              <h1 className='font-weight-bold'>Get in touch</h1>
              <p>We'd love to talk about how we can help you.</p>
            </div>
            <div>            
             <img src='/img/contactus.svg' className='w-100'></img>
            </div>

            <div class="row mt-5">
              <div class="col-sm-6">
                <div class="mb-5">
                  <span class="d-block h5 mb-1 font-weight-bold">Call us:</span>
                  <span class="d-block text-body font-size-1">
                    +91 9205134015
                  </span>
                </div>

                <div class="mb-3">
                  <span class="d-block h5 mb-1 font-weight-bold">Email us:</span>
                  <span class="d-block text-body font-size-1">
                    connect@induswam.com
                  </span>
                </div>
              </div>

              <div class="col-sm-6">
                <div class="mb-3">
                  <span class="d-block h5 mb-1 font-weight-bold">Registered Office:</span>
                  <span class="d-block text-body font-size-1">
                    952, Jai Ambe Apartment, New Kondli, Mayur Vihar Phase-3 Delhi-96
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="ml-lg-5">
              <form
                class="js-validate card shadow-lg mb-4"
                novalidate="novalidate"
              >
                <div class="card-header border-0 text-center py-4 px-4 px-md-6" style={{backgroundColor:'#d3d3d3'}}>
                  <h2 class="h4 mb-0 font-weight-bold" >General Enquiries</h2>
                </div>

                <div class="card-body p-4 p-md-6">
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="js-form-message form-group">
                        <label for="firstName" class="input-label">
                          First name
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="firstName"
                          id="firstName"
                          placeholder="Nataly"
                          aria-label="Nataly"
                          required=""
                          data-msg="Please enter first your name"
                        />
                      </div>
                    </div>

                    <div class="col-sm-6">
                      <div class="js-form-message form-group">
                        <label for="lastName" class="input-label">
                          Last name
                        </label>
                        <input
                          type="text"
                          class="form-control"
                          name="lastName"
                          id="lastName"
                          placeholder="Gaga"
                          aria-label="Gaga"
                          required=""
                          data-msg="Please enter last your name"
                        />
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div class="js-form-message form-group">
                        <label for="emailAddress" class="input-label">
                          Email address
                        </label>
                        <input
                          type="email"
                          class="form-control"
                          name="emailAddress"
                          id="emailAddress"
                          placeholder="nayagaga@pixeel.com"
                          aria-label="alex@pixeel.com"
                          required=""
                          data-msg="Please enter a valid email address"
                        />
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div class="js-form-message form-group">
                        <label for="message" class="input-label">
                          Message
                        </label>
                        <div class="input-group">
                          <textarea
                            class="form-control"
                            rows="4"
                            name="message"
                            id="message"
                            placeholder="Hi there, I would like to ..."
                            aria-label="Hi there, I would like to ..."
                            required=""
                            data-msg="Please enter a reason."
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button
                    type="submit"
                    class="btn btn-block btn-success transition-3d-hover"
                  >
                    Submit
                  </button>
                </div>
              </form>

              <div class="text-center">
                <p class="small">We'll get back to you in 1-2 business days.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
